import { createBrowserRouter } from "react-router-dom";
import Authorization from "../pages/Authorization";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Authorization />,
  },
]);
